import { TimeTrackingDashboardComponent } from "./main/accountant/jobs-and-tasks/time-tracking/time-tracking-dashboard/time-tracking-dashboard.component";
import { TimeTrackingModule } from "./main/accountant/jobs-and-tasks/time-tracking/time-tracking.module";
import { TimerService } from "./main/accountant/jobs-and-tasks/time-tracking/timer/timer.service";
import { JobUploadFileComponent } from "./main/accountant/jobs-and-tasks/job-content/job-upload-file/job-upload-file.component";
import { WelcomeService } from "./main/accountant/welcome/welcome.service";
import { WelcomeComponent } from "./main/accountant/welcome/welcome.component";

import { QuickBooksIntegrationComponent } from "./main/accountant/quickbooks-integration.component";
import { XeroIntegrationComponent } from "./main/accountant/xero-integration.component";
import { DeleteConfirmationModalComponent } from "./main/accountant/modals/delete-confirmation-modal.component";

import { PreferencesModalComponent } from "./main/common/modals/preferences-modal.component";
import { AngularResizeEventModule } from "angular-resize-event";

import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import {
  LocationStrategy,
  HashLocationStrategy,
  CommonModule,
  DatePipe,
} from "@angular/common";
import { BsModalRef, BsModalService, ModalModule } from "ngx-bootstrap/modal";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import {
  BsDropdownConfig,
  BsDropdownDirective,
  BsDropdownModule,
} from "ngx-bootstrap/dropdown";
import { PopoverModule } from "ngx-bootstrap/popover";
import { DragulaModule } from "ng2-dragula";
import { ColorPickerModule } from "ngx-color-picker";
import { PdfViewerModule } from "ng2-pdf-viewer";

import { ConversationsModule } from "./conversations/conversations.module";

// Components
import {
  ClientTagSearchPipe,
  DashboardComponent,
} from "./dashboard/dashboard.component";
import { MainDashboardComponent } from "./main/main.component";
import { AppsWidgetComponent } from "./main/common/apps.component";
import { FilePreviewComponent } from "./main/common/file-preview.component";
import { ResourcesWidgetComponent } from "./main/common/resources.component";

import { ClientlistWidgetComponent } from "./main/accountant/clientlist.component";
// import { PracticeinfoComponent } from "./main/accountant/practiceinfo.component";
import { AppsPageComponent } from "./main/accountant/apps-page.component";
import { ResourcesPageComponent } from "./main/accountant/resources-page.component";
import { ResourcesItemComponent } from "./main/common/resources-item.component";
import { AppsItemComponent } from "./main/common/apps-item.component";
import { GatewayPreviewComponent } from "./main/accountant/gateway-preview.component";
import { WorkspacesComponent } from "./main/accountant/workspaces.component";
import { ChatPanelComponent } from "./conversations/panels/chat-panel.component";
import { TrackedItemsPanelComponent } from "./conversations/panels/tracked-items-panel.component";
import { AppsPanelWidgetComponent } from "./main/panels/apps-panel.component";
import { ResourcesPanelWidgetComponent } from "./main/panels/resources-panel.component";
import { TrackedItemBubbleComponent } from "./conversations/tracked-item-bubble/tracked-item-bubble.component";
import { SubscriptionComponent } from "./main/accountant/subscription.component";

// Modals Components
import { AddClientModalComponent } from "./main/accountant/modals/addClientModal.component";
import { AddAccountantModalComponent } from "./main/accountant/modals/addAccountantModal.component";
import { ManageResourcesModalComponent } from "./main/accountant/modals/manage-resources-modal.component";
import { EditAppsModalComponent } from "./main/common/modals/edit-apps-modal.component";
import { EditResourcesModalComponent } from "./main/common/modals/edit-resources-modal.component";
import { AddAppsModalComponent } from "./main/accountant/modals/add-apps-modal.component";
import { OpenAppModalComponent } from "./main/common/modals/open-app-modal.component";
import { AccountantsAssignmentsModalComponent } from "./main/accountant/modals/accountants-assignments-modal.component";
import { MyAccountModalComponent } from "./main/common/modals/my-account-modal.component";

// Services
import { AddClientModalService } from "./main/accountant/modals/add-client-modal.service";
import { AddAppsModalService } from "./main/accountant/modals/add-apps-modal.service";
import { EditAppsModalService } from "./main/common/modals/edit-apps-modal.service";
import { EditResourcesModalService } from "./main/common/modals/edit-resources-modal.service";
import { MyAccountService } from "./main/common/modals/my-account-modal.service";
import { TrackedItemsDashboardService } from "./main/accountant/tracked-items-dashboard.service";

import { ClipboardModule } from "ngx-clipboard";

// Directives
import { DragDropDirective } from "./main/common/drag-drop.directive";

// Pipes
import { ResourceSearchPipe } from "./main/common/resources.pipes";
import { AppSearchPipe } from "./main/common/apps.pipes";
import { ActiveClientsOnlyPipe } from "./main/common/active-clients-only.pipe";
import { HistoryFormatterPipe } from "./main/accountant/jobs-and-tasks/job-content/history-formatter.pipe";

import { environment } from "../../environments/environment";

// Other imports
import { AuthGuard } from "../guards/auth.guard";

import { ClientGuard } from "../guards/client.guard";
import { AccountantGuard } from "../guards/accountant.guard";
import { TrackedItemsDashboardComponent } from "./main/accountant/tracked-items-dashboard.component";
import { ClientOnboardingGamePlanComponent } from "./main/accountant/client-onboarding-game-plan.component";
import { GeneralNotificationSettingsModalComponent } from "./main/common/modals/general-notification-settings-modal.component";
import { AddExistingClientModalComponent } from "./main/accountant/modals/addExistingClientModal.component";

import { MoveFileModalComponent } from "./main/accountant/modals/move-file-modal.component";
import { FileUploadModalComponent } from "./main/accountant/modals/file-upload-modal.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { RecentFilesComponent } from "./main/panels/recent-files.component";
import { JobsAndTasksComponent } from "./main/accountant/jobs-and-tasks/internal-workspace/jobs-and-tasks.component";
import { JobsAndTasksCardComponent } from "./main/accountant/jobs-and-tasks/jobs-and-tasks-card/jobs-and-tasks-card.component";
import { JobContentComponent } from "./main/accountant/jobs-and-tasks/job-content/job-content.component";
import { JobsDashboardComponent } from "./main/accountant/jobs-and-tasks/jobs-dashboard/jobs-dashboard/jobs-dashboard.component";

import { NotificationsComponent } from "./main/common/notifications/notifications.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { ClientTasksComponent } from "./main/accountant/client-tasks/client-tasks.component";

import { MentionModule } from "angular-mentions";
import { QuickAssignStaffModalComponent } from "./main/accountant/modals/quick-assign-staff-modal.component";
import { JobTemplatesComponent } from "./main/accountant/jobs-and-tasks/job-templates/job-templates.component";
import { AutosizeModule } from "ngx-autosize";

import { MyDevicesModalComponent } from "./main/common/modals/my-devices-modal.component";
import { TagComponent } from "./main/common/tags/tag.component";
import { TagAddComponent } from "./main/common/tags/tag-add/tag-add.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthInterceptor } from "../interceptors/auth.interceptor";
import { NewFilePreviewComponent } from "./main/common/new-file-preview.component";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { TableModule } from "primeng/table";
import { JobsListViewComponent } from "./main/accountant/jobs-and-tasks/job-list-view/job-list-view.component";
import { ButtonModule } from "primeng/button";
import { ProgressBarModule } from "primeng/progressbar";
import { InputTextModule } from "primeng/inputtext";
import { JobPickerModalComponent } from "./main/accountant/modals/job-picker-modal.component";
import { DrawerComponent } from "./drawer/drawer.component";
import { QboClientTasksComponent } from "./conversations/qbo-client-tasks/qbo-client-tasks.component";
import { QboClientTaskItemComponent } from "./conversations/qbo-client-tasks/qbo-client-task-item/qbo-client-task-item.component";
import { XeroClientTasksComponent } from "./conversations/xero-client-tasks/xero-client-tasks.component";
import { XeroClientTaskItemComponent } from "./conversations/xero-client-tasks/xero-client-task-item/xero-client-task-item.component";
import { ClientTaskCommentsComponent } from "./conversations/client-task-comments/client-task-comments.component";
import { CommentsIconComponent } from "../shared/comments-icon/comments-icon.component";
import { QboAccountsModalComponent } from "./main/accountant/qbo-accounts-modal/qbo-accounts-modal.component";
import { FilesManagerService } from "./files-manager/files-manager.service";
import { MomentModule } from "ngx-moment";

import { PaidOverlayDirective } from "./paid-overlay.directive";

import { XeroAccountsModalComponent } from "./main/accountant/xero-accounts-modal/xero-accounts-modal.component";

import { InviteMessageComponent } from "./templates/default-workspace/invite-message/invite-message.component";
import { DfWorkspaceComponent } from "./templates/default-workspace/df-workspace/df-workspace.component";
import { FoldersComponent } from "./templates/default-workspace/folders/folders.component";
import { AppsAndResourcesComponent } from "./templates/default-workspace/apps-and-resources/apps-and-resources.component";
import { DfClientTasksComponent } from "./templates/default-workspace/df-client-tasks/df-client-tasks.component";
import { GettingStartedComponent } from "./main/accountant/getting-started/getting-started.component";
import { TemplatesComponent } from "./templates/templates.component";
// import { HuddleComponent } from "./conversations/huddle/huddle.component";
// import { HuddleWidgetComponent } from "./main/panels/huddle-widget.component";
import { NotesComponent } from "./main/accountant/notes/notes.component";
import { NewNoteModalComponent } from "./main/accountant/notes/new-note-modal/new-note-modal.component";
import { NoteCardComponent } from "./main/accountant/notes/note-card/note-card.component";
import { EditNoteCardModalComponent } from "./main/accountant/notes/edit-note-card-modal/edit-note-card-modal.component";
import { PinnedPanelComponent } from "./main/accountant/pinned-panel/pinned-panel.component";
import { PinnedCardComponent } from "./main/accountant/pinned-panel/pinned-card/pinned-card.component";
import { EmailModule } from "./email/email.module";

import { CSVBoxAngularModule } from "@csvbox/angular";
import { SetupAndSettingsComponent } from "./main/accountant/setup-and-settings/setup-and-settings.component";
import { ClientContactFieldsComponent } from "./main/accountant/setup-and-settings/client-contact-fields/client-contact-fields.component";
import { ContactFieldsComponent } from "./main/accountant/setup-and-settings/contact-fields/contact-fields.component";
import { BatchAssignJobsComponent } from "./main/accountant/setup-and-settings/batch-assign-jobs/batch-assign-jobs.component";
import { ConnectEmailComponent } from "./main/accountant/setup-and-settings/connect-email/connect-email.component";
import { ClientPortalDesignComponent } from "./main/accountant/setup-and-settings/client-portal-design/client-portal-design.component";
import { InitialClientTaskComponent } from "./main/accountant/setup-and-settings/initial-client-task/initial-client-task.component";
import { LinksComponent } from "./main/accountant/setup-and-settings/links/links.component";
import { InviteClientsComponent } from "./main/accountant/setup-and-settings/invite-clients/invite-clients.component";
import { QuickbooksIntegrationComponent } from "./main/accountant/setup-and-settings/quickbooks-integration/quickbooks-integration.component";
import { TagsLibraryComponent } from "./main/accountant/setup-and-settings/tags-library/tags-library.component";
import { BulkChangeOwnershipModalComponent } from "./main/accountant/jobs-and-tasks/jobs-dashboard/bulk-actions/bulk-change-ownership-modal.component";
import { BulkEditTagsModalComponent } from "./main/accountant/jobs-and-tasks/jobs-dashboard/bulk-actions/bulk-edit-tags-modal.component";
import { DropdownModule } from "primeng/dropdown";
import { ConfirmationModalComponent } from "./main/accountant/modals/confirmation-modal.component";
import { DataFieldFor } from "./main/accountant/setup-and-settings/client-contact-fields/models";
import { ImportDataComponent } from "./main/accountant/setup-and-settings/import-data/import-data.component";
import { SignRequestModalComponent } from "./files-manager/sign-request/sign-request-modal.component";
import { EscapeUrlPipe } from "./main/common/escape-url.pipe";
import { SignPreviewComponent } from "./files-manager/sign-preview/sign-preview.component";
import { PinFilterComponent } from "./components/pin-filter/pin-filter.component";
import { SecureDeleteConfirmationModalComponent } from "./main/accountant/modals/secure-delete-confirmation-modal.component";
import { UploadProgressBarComponent } from "../utils/upload-progress-bar/upload-progress-bar.component";

import { CustomDataDashboardComponent } from "./custom-data-dashboard/custom-data-dashboard.component";
import { UserDataDashboardComponent } from "./user-data-dashboard/user-data-dashboard.component";
import { PinnedItemsDashboardComponent } from "./pinned-items-dashboard/pinned-items-dashboard.component";
import { DatePickerModule } from "primeng/datepicker";
import { PremiumOverlayDirective } from "./premium-overlay.directive";
import { UnsavedChangesGuard } from "src/app/unsaved-changes.guard";
import { BalanceSheetReviewComponent } from "./main/accountant/books-review/balance-sheet-review/balance-sheet-review.component";
import { InvitesDashboardComponent } from "./invites-dashboard/invites-dashboard.component";
import { RoleGuard } from "../guards/role.guard";
import { PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS, ROLE_ADMIN } from "../services/authorization/authorization.models";
import { PermissionGuard } from "../guards/permission.guard";
const routes: Routes = [
  {
    path: "practice",

    loadComponent: () =>
      import("./dashboard/dashboard.component").then(
        (mod) => mod.DashboardComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "practice-info",
        loadComponent: () =>
          import("./practice-info/practice-info.component").then(
            (mod) => mod.PracticeinfoComponent,
          ),
        canActivate: [RoleGuard],
        data: { allowedRoles: [ROLE_ADMIN] },
      },
      {
        path: "manage-apps",
        loadComponent: () =>
          import("./main/accountant/apps-page.component").then(
            (mod) => mod.AppsPageComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "manage-resources",
        loadComponent: () =>
          import("./main/accountant/resources-page.component").then(
            (mod) => mod.ResourcesPageComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "workspaces",
        loadComponent: () =>
          import("./main/accountant/workspaces.component").then(
            (mod) => mod.WorkspacesComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "workspaces/:id",
        loadComponent: () =>
          import("./main/accountant/workspaces.component").then(
            (mod) => mod.WorkspacesComponent,
          ),
        canActivate: [AccountantGuard],
        children: [
          {
            path: "jobs",
            loadComponent: () =>
              import(
                "./main/accountant/jobs-and-tasks/internal-workspace/jobs-and-tasks.component"
              ).then((mod) => mod.JobsAndTasksComponent),

            canActivate: [AccountantGuard],
          },
          {
            path: "conversations",
            loadComponent: () =>
              import("./client-workspace/client-workspace.component").then(
                (mod) => mod.ClientWorkspaceComponent,
              ),
            canActivate: [AccountantGuard],
          },
          {
            path: "files",
            loadComponent: () =>
              import("./files-manager/files-manager.component").then(
                (mod) => mod.FilesManagerComponent,
              ),
            canActivate: [AccountantGuard],
            canDeactivate: [UnsavedChangesGuard],
          },
          {
            path: "details",
            loadComponent: () =>
              import("./client-details-v2/client-details-v2.component").then(
                (mod) => mod.ClientDetailsV2Component,
              ),
            canActivate: [AccountantGuard],
          },
          {
            path: "books-review",
            loadComponent: () =>
              import(
                "./main/accountant/books-review/books-review.component"
              ).then((mod) => mod.BooksReviewComponent),
            canActivate: [AccountantGuard],
            children: [
              // {
              //   path: "",
              //   redirectTo: "inconsistencies",
              //   pathMatch: "full",
              // },
              {
                path: "inconsistencies",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/inconsistencies/inconsistencies.component"
                  ).then((mod) => mod.InconsistenciesComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "transactions-without-payee",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/transactions-without-payee/transactions-without-payee.component"
                  ).then((mod) => mod.TransactionsWithoutPayeeComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "large-transactions",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/large-transactions/large-transactions.component"
                  ).then((mod) => mod.LargeTransactionsComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "purchases-coded-to-parent-accounts",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/purchases-coded-to-parent-accounts/purchases-coded-to-parent-accounts.component"
                  ).then((mod) => mod.PurchasesCodedToParentAccountsComponent),
              },
              {
                path: "new-vendors",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/new-vendors/new-vendors.component"
                  ).then((mod) => mod.NewVendorsComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "new-accounts",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/new-accounts/new-accounts.component"
                  ).then((mod) => mod.NewAccountsComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "new-customers",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/new-customers/new-customers.component"
                  ).then((mod) => mod.NewCustomersComponent),
                canActivate: [AccountantGuard],
              },
              {
                path: "balance-sheet-review",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/balance-sheet-review/balance-sheet-review.component"
                  ).then((mod) => mod.BalanceSheetReviewComponent),
              },
              {
                path: "profit-and-loss-review",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/profit-and-loss-review/profit-and-loss-review.component"
                  ).then((mod) => mod.ProfitAndLossReviewComponent),
              },
              {
                path: "transactions-without-attachments",
                loadComponent: () =>
                  import(
                    "./main/accountant/books-review/transactions-without-attachments/transactions-without-attachments.component"
                  ).then((mod) => mod.TransactionsWithoutAttachmentsComponent),
              },
            ],
          },
          {
            path: "recategorize",
            component: QboClientTasksComponent,
            canActivate: [AccountantGuard],
          },
        ],
        canDeactivate: [],
      },
      {
        path: "templates",
        loadComponent: () =>
          import("./templates/templates.component").then(
            (mod) => mod.TemplatesComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "client-onboarding-game-plan",
        component: ClientOnboardingGamePlanComponent,
        canActivate: [AccountantGuard],
      },
      { path: "subscription", component: SubscriptionComponent },
      {
        path: "dashboards",
        loadComponent: () =>
          import("./dashboards-tab/dashboards-tab.component").then(
            (mod) => mod.DashboardsTabComponent,
          ),
        canActivate: [AccountantGuard],
        children: [
          {
            path: "",
            redirectTo: "jobs-dashboard",
            pathMatch: "full",
          },
          {
            path: "jobs-dashboard",
            loadComponent: () =>
              import(
                "./main/accountant/jobs-and-tasks/jobs-dashboard/jobs-dashboard/jobs-dashboard.component"
              ).then((mod) => mod.JobsDashboardComponent),
            canActivate: [AccountantGuard],
          },
          {
            path: "client-tasks-dashboard",

            loadComponent: () =>
              import(
                "./main/accountant/tracked-items-dashboard.component"
              ).then((mod) => mod.TrackedItemsDashboardComponent),

            canActivate: [AccountantGuard],
          },
          {
            path: "time-tracking-dashboard",

            loadComponent: () =>
              import(
                "./main/accountant/jobs-and-tasks/time-tracking/time-tracking-dashboard/time-tracking-dashboard.component"
              ).then((mod) => mod.TimeTrackingDashboardComponent),

            canActivate: [AccountantGuard],
          },
          {
            path: "custom-data-dashboard",
            loadComponent: () =>
              import(
                "./custom-data-dashboard/custom-data-dashboard.component"
              ).then((mod) => mod.CustomDataDashboardComponent),
            canActivate: [AccountantGuard],
          },
          {
            path: "users-data-dashboard",
            loadComponent: () =>
              import(
                "./user-data-dashboard/user-data-dashboard.component"
              ).then((mod) => mod.UserDataDashboardComponent),

            canActivate: [AccountantGuard],
          },
          {
            path: "invites-dashboard",
            loadComponent: () =>
              import("./invites-dashboard/invites-dashboard.component").then(
                (mod) => mod.InvitesDashboardComponent,
              ),

            canActivate: [AccountantGuard],
          },
          {
            path: "pinned-dashboard",
            loadComponent: () =>
              import(
                "./pinned-items-dashboard/pinned-items-dashboard.component"
              ).then((mod) => mod.PinnedItemsDashboardComponent),

            canActivate: [AccountantGuard],
          },
        ],
      },
      {
        path: "welcome",

        loadComponent: () =>
          import("./main/accountant/welcome/welcome.component").then(
            (mod) => mod.WelcomeComponent,
          ),

        canActivate: [AccountantGuard],
      },
      {
        path: "referral-program",

        loadComponent: () =>
          import(
            "./main/accountant/referral-program/referral-program.component"
          ).then((mod) => mod.ReferralProgramComponent),

        canActivate: [AccountantGuard],
      },
      {
        path: "user-survey",
        loadComponent: () =>
          import("./main/accountant/user-survey/user-survey.component").then(
            (mod) => mod.UserSurveyComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "getting-started",
        component: GettingStartedComponent,
        canActivate: [AccountantGuard],
      },
      {
        path: "email",
        loadChildren: () =>
          import("./email/email.module").then((mod) => mod.EmailModule),
        canActivate: [AccountantGuard],
      },
      {
        path: "wizard",
        loadComponent: () =>
          import("../add-client-wizard/add-client-wizard.component").then(
            (mod) => mod.AddClientWizardComponent,
          ),
        canActivate: [AccountantGuard],
      },
      {
        path: "setup-and-settings",
        component: SetupAndSettingsComponent,
        canActivate: [AccountantGuard, PermissionGuard],
        data: {
          permissionsRequired: [
            PERMISSION_GENERAL_ACCESS_SETUP_AND_SETTINGS,],
          roleOverride: ROLE_ADMIN
        },
        children: [
          {
            path: "",
            redirectTo: "initial-folders",
            pathMatch: "full",
          },
          {
            path: "initial-folders",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/initial-folders/initial-folders.component"
              ).then((mod) => mod.InitialFoldersComponent),
          },
          {
            path: "client-fields",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/client-contact-fields/client-contact-fields.component"
              ).then((mod) => mod.ClientContactFieldsComponent),
            data: {
              componentFor: DataFieldFor.Company,
            },
          },
          {
            path: "contact-fields",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/client-contact-fields/client-contact-fields.component"
              ).then((mod) => mod.ClientContactFieldsComponent),
            data: {
              componentFor: DataFieldFor.Contact,
            },
          },
          {
            path: "adding-clients",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/adding-clients/adding-clients.component"
              ).then((mod) => mod.AddingClientsComponent),
            data: {
              componentFor: DataFieldFor.Company,
            },
          },
          {
            path: "import-clients",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/import-data/import-data.component"
              ).then((mod) => mod.ImportDataComponent),
            data: {
              componentFor: DataFieldFor.Company,
            },
          },
          {
            path: "import-contacts",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/import-data/import-data.component"
              ).then((mod) => mod.ImportDataComponent),
            data: {
              componentFor: DataFieldFor.Contact,
            },
          },
          {
            path: "adding-jobs",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/adding-jobs/adding-jobs.component"
              ).then((mod) => mod.AddingJobsComponent),
          },
          {
            path: "batch-assign-jobs",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/batch-assign-jobs/batch-assign-jobs.component"
              ).then((mod) => mod.BatchAssignJobsComponent),
          },
          {
            path: "connect-email",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/connect-email/connect-email.component"
              ).then((mod) => mod.ConnectEmailComponent),
          },
          {
            path: "client-portal-design",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/client-portal-design/client-portal-design.component"
              ).then((mod) => mod.ClientPortalDesignComponent),
          },
          {
            path: "invite-message",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/invite-message/invite-message.component"
              ).then((mod) => mod.InviteMessageComponent),
          },
          {
            path: "initial-client-task",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/initial-client-task/initial-client-task.component"
              ).then((mod) => mod.InitialClientTaskComponent),
          },
          {
            path: "links",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/links/links.component"
              ).then((mod) => mod.LinksComponent),
          },
          {
            path: "invite-clients",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/invite-clients/invite-clients.component"
              ).then((mod) => mod.InviteClientsComponent),
          },
          {
            path: "quickbooks-integration",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/quickbooks-integration/quickbooks-integration.component"
              ).then((mod) => mod.QuickbooksIntegrationComponent),
          },
          {
            path: "xero-integration",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/xero-integration/xero-integration.component"
              ).then((mod) => mod.XeroIntegrationComponent),
          },
          {
            path: "anchor",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/anchor/anchor.component"
              ).then((mod) => mod.AnchorComponent),
          },
          {
            path: "tags-library",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/tags-library/tags-library.component"
              ).then((mod) => mod.TagsLibraryComponent),
          },
          {
            path: "apps-library",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/apps-library/apps-library.component"
              ).then((mod) => mod.AppsLibraryComponent),
          },
          {
            path: "resources-library",
            loadComponent: () =>
              import(
                "./main/accountant/setup-and-settings/resources-library/resources-library.component"
              ).then((mod) => mod.ResourcesLibraryComponent),
          },
        ],
      },
    ],
  },

  {
    path: "client",
    component: DashboardComponent,
    canActivate: [AuthGuard, ClientGuard],
    children: [
      {
        path: "workspaces",
        component: WorkspacesComponent,
        canActivate: [ClientGuard],
      },
      {
        path: "workspaces/:id",
        component: WorkspacesComponent,
        canActivate: [ClientGuard],
        children: [
          {
            path: "conversations",
            loadComponent: () =>
              import("./client-workspace/client-workspace.component").then(
                (mod) => mod.ClientWorkspaceComponent,
              ),
          },
          {
            path: "files",
            loadComponent: () =>
              import("./files-manager/files-manager.component").then(
                (mod) => mod.FilesManagerComponent,
              ),
          },
          {
            path: "recategorize",
            component: QboClientTasksComponent,
          },
        ],
      },
    ],
  },
  {
    path: "preview",
    component: GatewayPreviewComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  exports: [
    DfWorkspaceComponent,
    DashboardComponent,
    MainDashboardComponent,
    AppsWidgetComponent,
    ResourcesWidgetComponent,
    JobsAndTasksComponent,
    JobsAndTasksCardComponent,
    RecentFilesComponent,
    QuickBooksIntegrationComponent,
    XeroIntegrationComponent,

    MentionModule,
    TagComponent,
    JobTemplatesComponent,
    TrackedItemBubbleComponent,
    ClientTasksComponent,
    TrackedItemsPanelComponent,
    ChatPanelComponent,
    AppsPanelWidgetComponent,
    // HuddleWidgetComponent,
    ResourcesPanelWidgetComponent,
    MomentModule,
    TagAddComponent,
    CustomDataDashboardComponent,
    InvitesDashboardComponent,
    TagComponent,
    FilePreviewComponent,
    PaidOverlayDirective,
    PremiumOverlayDirective,
    DropdownModule,
    AppsItemComponent,
    ResourcesItemComponent,
    NoteCardComponent,
    PinFilterComponent,
    PinnedCardComponent,
    PinnedPanelComponent,
  ],
  imports: [
    // TemplatesComponent,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    PdfViewerModule,
    RouterModule.forChild(routes),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    DragulaModule.forRoot(),
    ColorPickerModule,
    ClipboardModule,
    ConversationsModule,
    DatePickerModule,
    TypeaheadModule.forRoot(),
    ImageCropperModule,
    MentionModule,
    AutosizeModule,
    NgxDocViewerModule,
    TableModule,
    ButtonModule,
    ProgressBarModule,
    InputTextModule,
    TimeTrackingModule,
    AngularResizeEventModule,
    EmailModule,
    AppSearchPipe,
    CSVBoxAngularModule,
    DropdownModule,
    ActiveClientsOnlyPipe,
    ResourceSearchPipe,
    PinFilterComponent,
    DashboardComponent,
    MainDashboardComponent,
    AppsWidgetComponent,
    ResourcesWidgetComponent,
    JobsAndTasksComponent,
    JobsAndTasksCardComponent,
    JobTemplatesComponent,
    RecentFilesComponent,
    QuickBooksIntegrationComponent,
    XeroIntegrationComponent,
    ClientlistWidgetComponent,
    // PracticeinfoComponent,
    WorkspacesComponent,
    TrackedItemsDashboardComponent,
    ClientOnboardingGamePlanComponent,
    AddClientModalComponent,
    MoveFileModalComponent,
    ConfirmationModalComponent,
    DeleteConfirmationModalComponent,
    FileUploadModalComponent,
    AddExistingClientModalComponent,
    QuickAssignStaffModalComponent,
    AddAccountantModalComponent,
    ManageResourcesModalComponent,
    EditAppsModalComponent,
    EditResourcesModalComponent,
    AddAppsModalComponent,
    OpenAppModalComponent,
    AccountantsAssignmentsModalComponent,
    MyAccountModalComponent,
    MyDevicesModalComponent,
    PreferencesModalComponent,
    GeneralNotificationSettingsModalComponent,
    AppsPageComponent,
    ResourcesPageComponent,
    ResourcesItemComponent,
    GatewayPreviewComponent,
    AppsItemComponent,
    ChatPanelComponent,
    TrackedItemsPanelComponent,
    AppsPanelWidgetComponent,
    ResourcesPanelWidgetComponent,
    TrackedItemBubbleComponent,
    SubscriptionComponent,
    InviteMessageComponent,
    // InitialsDirective,
    DragDropDirective,
    ClientTagSearchPipe,
    JobContentComponent,
    JobUploadFileComponent,
    JobsDashboardComponent,
    NotificationsComponent,
    ClientTasksComponent,
    WelcomeComponent,
    TagComponent,
    TagAddComponent,
    NewFilePreviewComponent,
    HistoryFormatterPipe,
    JobsListViewComponent,
    JobPickerModalComponent,
    DrawerComponent,
    QboClientTasksComponent,
    QboClientTaskItemComponent,
    XeroClientTasksComponent,
    XeroClientTaskItemComponent,
    ClientTaskCommentsComponent,
    CommentsIconComponent,
    QboAccountsModalComponent,
    PaidOverlayDirective,
    PremiumOverlayDirective,
    InviteMessageComponent,
    DfWorkspaceComponent,
    FoldersComponent,
    AppsAndResourcesComponent,
    DfClientTasksComponent,
    GettingStartedComponent,
    XeroAccountsModalComponent,
    // HuddleWidgetComponent,
    // HuddleComponent,
    NotesComponent,
    NewNoteModalComponent,
    NoteCardComponent,
    EditNoteCardModalComponent,
    SignRequestModalComponent,
    EscapeUrlPipe,
    SetupAndSettingsComponent,
    BulkChangeOwnershipModalComponent,
    BulkEditTagsModalComponent,
    SignPreviewComponent,
    SecureDeleteConfirmationModalComponent,
    CustomDataDashboardComponent,
    UserDataDashboardComponent,
    InvitesDashboardComponent,
    PinnedItemsDashboardComponent,
    PinnedPanelComponent,
    PinnedCardComponent,
  ],
  providers: [
    AddClientModalService,
    AddAppsModalService,
    EditAppsModalService,
    EditResourcesModalService,
    TimerService,
    MyAccountService,
    TrackedItemsDashboardService,
    WelcomeService,
    AuthGuard,
    DatePipe,
    BsDropdownDirective,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: BsDropdownConfig, useValue: {} },
    BsModalRef,
    BsModalService,
  ],
})
export class DashboardModule {}
